import { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { JDOPSProductMapping } from "./JDOpsProductsMapping";
import { Products } from "./Products";

import { styled } from '@mui/system';

const StyledTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    backgroundColor: '#1976D2', // Blue indicator
    height: '4px',
    borderRadius: '2px',
  },
});

const StyledTab = styled(Tab)({
  textTransform: 'none', 
  fontWeight: 'bold',
  fontSize: '16px',
  color: '#555', 
  '&.Mui-selected': {
    color: '#1976D2', // Blue color for selected tab
  },
  '&:hover': {
    color: '#1976D2', // Blue color on hover
    opacity: 0.8,
  },
});
const ProductsPricing = () => {
  const [tabIndex, setTabIndex] = useState<number>(0);

  const handleTabChange = (event: any, newValue: number) => {
    console.log(event.value);
    setTabIndex(newValue);
  };

  return (
    <Box>
      <StyledTabs value={tabIndex} onChange={handleTabChange}>
        <StyledTab label="Products" />
        <StyledTab label="JD OPs Products Mapping" />
      </StyledTabs>
      {tabIndex === 0 && <Products />}
      {tabIndex === 1 && <JDOPSProductMapping />}
    </Box>
  );
};

export default ProductsPricing;
